/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const REGISTERS = ['formal', 'neutral', 'informal', 'slang', 'vulgar'] as const;

export const registerSchema = z.enum(REGISTERS);

export type IRegister = z.infer<typeof registerSchema>;
